const initialState = {
  orderHistory: [],
  orderListing: [],
};

const OrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ORDERS_HISTORY':
      return { ...state, orderHistory: action.payload };
    case 'GET_ORDERS_LISTING':
      return { ...state, orderListing: action.payload };
    default:
      return state;
  }
};

export default OrdersReducer;
